import { takeLatest, put, call, select } from 'redux-saga/effects';
import ApiCall from './ApiCall';
import CaseTransformer from '../../helpers/CaseTransformer';

function* ApiResponse() {
  try {
    const { UserIdData = {}, SignatureData = {} } = yield select();
    const { uuid = 0 } = UserIdData;
    const body = CaseTransformer.keysToSnake(SignatureData);
    const response = yield call(() =>
      ApiCall('/application/declarationStep', { ...body, uuid }, true)
    );

    yield put({
      type: 'GET_SIGNATURE_DETAILS_FULFILLED',
      payload: {
        data: response.data.data,
      },
    });
    yield put({
      type: 'CHANGE_SCREEN',
      payload: {
        link: '/summary',
      },
    });
  } catch (e) {
    yield put({
      type: 'API_REJECTED',
      payload: e.response.data,
    });
    yield put({
      type: 'DISABLE_SPINNER',
      payload: e.response.data,
    });
    yield put({
      type: 'CANCEL_SUBMIT',
      payload: e.response.data,
    });
  }
}
function* watchLastFetchUser() {
  yield takeLatest('SUBMIT_SIGNATURE_DATA', ApiResponse);
}

export default watchLastFetchUser;
